import * as fromMailMerges from './mail-merges.actions';
import { mailMergesAdapter, MailMergesState, initialState } from './mail-merges.interfaces';

export function reducer(
  state: MailMergesState = initialState,
  action: fromMailMerges.MailMergesAction
): MailMergesState {
  switch (action.type) {
    case fromMailMerges.GET_MAIL_MERGES_FROM_SERVER_SUCCESS: {
      return {
        ...mailMergesAdapter.addMany(action.payload.mailMerges, state)
      };
    }

    default: {
      return state;
    }
  }
}
